import { render } from "./Community.vue?vue&type=template&id=a2f3a302"
import script from "./Community.vue?vue&type=script&lang=js"
export * from "./Community.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/mydid-badgechecker-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__